module.exports = __webpack_public_path__ + "static/hackathon-kickoff-min-e5a1495fb64a61e4f64406da51c9da89.jpg";